import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE } from "../config/vars";

const readErrorMessage = async (res, fallback) => {
    const err = await res.json().catch(() => ({}));
    return err?.detail || fallback;
};

// 🔹 Локації / квартири (для створення переписки з мешканцем)
export const getLocationsUsed = async () => {
    const res = await apiFetch(`${API_BASE}/clients/operator/locations_used`);
    if (!res.ok) throw new Error(await readErrorMessage(res, "Не вдалося завантажити список локацій"));
    return await res.json();
};

export const getApartmentsByLocation = async (locationId) => {
    const res = await apiFetch(
        `${API_BASE}/clients/operator/apartments_by_location?location_id=${encodeURIComponent(locationId)}`,
    );
    if (!res.ok) throw new Error(await readErrorMessage(res, "Не вдалося завантажити список квартир"));
    return await res.json();
};

// 🔹 Створити нову розмову
export const createConversation = async (data) => {
    const res = await apiFetch(`${API_BASE}/chat/operator/create`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
    if (!res.ok) {
        throw new Error(await readErrorMessage(res, "Не вдалося створити переписку"));
    }
    return await res.json();
};

// 🔹 Відправити текстове повідомлення
export const sendMessage = async (payload) => {
    const res = await apiFetch(`${API_BASE}/chat/operator/message`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });
    if (!res.ok) {
        throw new Error(await readErrorMessage(res, "Не вдалося відправити повідомлення"));
    }
    return await res.json();
};

// 🔹 Відправити повідомлення з файлом
export const sendMessageWithFile = async (headId, text, file) => {
    const formData = new FormData();
    formData.append("head_id", headId);
    formData.append("text", text || "");
    formData.append("file", file);

    const res = await apiFetch(`${API_BASE}/chat/operator/message/upload`, {
        method: "POST",
        body: formData,
    });

    if (!res.ok) {
        throw new Error(await readErrorMessage(res, "Не вдалося відправити файл"));
    }
    return await res.json();
};

// 🔹 Отримати повідомлення
export const getConversationMessages = async (headId) => {
    const res = await apiFetch(`${API_BASE}/chat/operator/${headId}/messages`);
    if (!res.ok) throw new Error("Не вдалося завантажити повідомлення");
    return await res.json();
};

// 🔹 Список активних переписок (to-me)
export const getToMeConversations = async (mode = "") => {
    const url = new URL(`${API_BASE}/chat/operator/to-me`);
    if (mode) url.searchParams.set("mode", mode);

    const res = await apiFetch(url.toString());
    if (!res.ok) {
        const txt = await res.text();
        throw new Error("Не вдалося завантажити активні переписки: " + txt);
    }
    return await res.json();
};

// 🔹 Список архівних переписок
export const getArchivedConversations = async (mode = "") => {
    const url = new URL(`${API_BASE}/chat/operator/archived`);
    if (mode) url.searchParams.set("mode", mode);

    const res = await apiFetch(url.toString());
    if (!res.ok) {
        const txt = await res.text();
        throw new Error("Не вдалося завантажити архівні переписки: " + txt);
    }
    return await res.json();
};

// 🔹 Архівувати розмову
export const archiveConversation = async (headId) => {
    const res = await apiFetch(`${API_BASE}/chat/operator/${headId}/archive`, {
        method: "PUT",
    });
    if (!res.ok) {
        const txt = await res.text();
        throw new Error("Не вдалося архівувати розмову: " + txt);
    }
    return await res.json();
};


// 🔹Список переписок адресованих мені (старий метод, тепер використовуємо getToMeConversations)
export const getAssignedToMeConversations = async () => {
    return getToMeConversations();
};